import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, MapPin } from 'lucide-react';
export function LiveEventSection() {
  const attendees = ['Entrepreneurs', 'Investors', 'Ecosystem Leaders', 'Financial Institutions', 'Succession Experts', 'Acquisition Entrepreneurs'];
  return <section className="py-24 bg-gray-50 border-y border-gray-200" data-id="element-145">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-146">
        <div className="grid lg:grid-cols-5 gap-12 items-center" data-id="element-147">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="lg:col-span-3" data-id="element-148">
            <div className="inline-block px-4 py-1.5 rounded-full bg-brand-teal text-white text-sm font-semibold mb-6 tracking-wide uppercase" data-id="element-149">
              Event Details Confirmed
            </div>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-brand-black mb-6" data-id="element-150">
              Official Findings Presentation
            </h2>
            <p className="text-xl text-gray-600 font-light mb-8 leading-relaxed max-w-2xl" data-id="element-151">
              Join us for the live presentation of Inclusive Succession at BDC's
              downtown Toronto headquarters. This event will bring together key
              players shaping the future of Canadian business ownership.
            </p>

            <div className="flex flex-col gap-4 mb-10" data-id="element-152">
              <div className="flex items-start gap-3 text-gray-700 font-medium" data-id="element-153">
                <Calendar className="w-5 h-5 text-brand-teal flex-shrink-0 mt-0.5" data-id="element-154" />
                <div data-id="element-155">
                  <div data-id="element-156">June 15, 2026</div>
                  <div className="text-sm text-gray-500" data-id="element-157">5:00 PM – 7:30 PM</div>
                </div>
              </div>
              <div className="flex items-start gap-3 text-gray-700 font-medium" data-id="element-158">
                <MapPin className="w-5 h-5 text-brand-teal flex-shrink-0 mt-0.5" data-id="element-159" />
                <div data-id="element-160">
                  <div data-id="element-161">BDC · Business Development Bank of Canada</div>
                  <div className="text-sm text-gray-500" data-id="element-162">
                    CIBC Square, 81 Bay Street, Toronto, ON
                  </div>
                </div>
              </div>
            </div>

            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="bg-brand-teal text-white px-8 py-4 rounded-full font-semibold text-lg shadow-md hover:bg-brand-tealDark transition-colors duration-300" data-id="element-163">
              Reserve Early Access
            </motion.button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:col-span-2 bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-164">
            <h3 className="text-lg font-bold text-brand-black mb-6 uppercase tracking-wider" data-id="element-165">
              Who Should Attend
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-166">
              {attendees.map((item, idx) => <div key={idx} className="flex items-center gap-3 p-3 rounded-lg bg-gray-50 border border-gray-100" data-id="element-167">
                  <div className="w-2 h-2 rounded-full bg-brand-teal" data-id="element-168"></div>
                  <span className="text-gray-700 font-medium text-sm" data-id="element-169">
                    {item}
                  </span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}